module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-purple.e11b0f72.svg";